<template>
  <component :is="htmlTag" v-if="show" :class="[name]" :style="cssVars">
    <slot />
  </component>
</template>

<script>
import { mapGetters } from 'vuex'
import Viewports from '~/mixins/viewports'
export default {
  mixins: [Viewports],
  props: {
    htmlTag: {
      type: String,
      default: 'div',
    },
    layout: {
      type: Array,
      default() {
        return [{ size: 1, columns: 'repeat(12, 1fr)' }]
      },
    },
  },

  data() {
    return {
      name: 'grid',
      show: false,
    }
  },

  computed: {
    ...mapGetters({
      mq: 'globals/getMq',
    }),
    cssVars() {
      const options = Object.assign({}, this.viewport)
      return {
        '--display': options.inline ? 'inline-grid' : 'grid',
        '--grid-template-columns': options.columns,
        '--grid-template-rows': options.rows,
        '--grid-template-areas': this.areasCss(options.areas),
        '--grid-gap': options.gap,
        '--grid-auto-rows': options.autoRows,
        '--grid-auto-columns': options.autoColumns,
        '--justify-items': options.justifyItems,
        '--justify-content': options.justifyContent,
        '--align-items': options.alignItems,
        '--align-content': options.alignContent,
        '--grid-auto-flow': options.autoFlow,
      }
    },
  },

  mounted() {
    if ((this.mq || {}).length > 0) {
      this.show = true
    }
  },

  methods: {
    areasCss(areas) {
      if (!areas) {
        return null
      }
      return areas
        .map((row) => {
          return `"${row.join(' ')}"`
        })
        .join(' ')
    },
  },
}
</script>

<style lang="scss" scoped>
.grid {
  display: var(--display);
  grid-template-columns: var(--grid-template-columns);
  grid-template-rows: var(--grid-template-rows);
  grid-template-areas: var(--grid-template-areas);
  grid-gap: var(--grid-gap);
  grid-auto-rows: var(--grid-auto-rows);
  grid-auto-columns: var(--grid-auto-columns);
  grid-auto-flow: var(--grid-auto-flow);

  &--container {
    @include container();

    min-height: inherit;
    display: grid;
  }
}
</style>
